import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FullPanelModalComponent } from '../full-panel-modal/full-panel-modal.component';
import { RouterFacade } from '../../../store/router.facade';

@Component({
  selector: 'app-modal-outlet-container',
  imports: [RouterOutlet, FullPanelModalComponent],
  templateUrl: './modal-outlet-container.component.html',
  styleUrls: ['./modal-outlet-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalOutletContainerComponent {
  private readonly routerFacade = inject(RouterFacade);

  protected isModalOpen = computed(() => this.routerFacade.hasModalOutletRoute());

  protected onClose(): void {
    this.routerFacade.clearModalOutlet();
  }
}
